import { AuthConsumer, useAuth } from 'providers/authProvider'
import { ReactElement, useContext, useEffect } from 'react';
import LoadingScreen from '../../components/loading-screen';

export const SigninOIDC = ({ signinRedirectCallback }: any): ReactElement => {
    const auth = useAuth();
    
    useEffect(() => {
        
        auth.signinRedirectCallback();
    }, []);

    return (
        <AuthConsumer>
            {({ signinRedirectCallback }) => {
                return <LoadingScreen />
            }}
        </AuthConsumer>
    );
}